export default __webpack_public_path__ + "static/media/outreach2.6c1c2148.svg";